import styled from 'styled-components'

import { SectionFrame } from './Section'

export const Footer = styled(SectionFrame).attrs({ as: 'footer' })``
